import styled from '@emotion/styled';
import { colors } from 'theme/colors';

export const StyledInfoItem = styled.div`
  display: flex;
  width: fit-content;
  gap: 4px;
  height: 30px;
  align-items: center;
  background: ${colors.primary600};
  color: ${colors.white};
  height: 20px;
  padding: 0px 8px 0px 2px;
  margin: 4px 0px;
  border-radius: 4px;

  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0;

  & span {
    padding-top: 3px;
  }
`;
